<template>
    <div class="fixed-right">
        <div class="fixed-rule" @click="onRule">
            <p class="fixed-rule-text g-flex-center-center">规则</p>
        </div>
        <div class="fixed-item fixed-item-first" @click="onRanking">
            <div class="icon-ranking"></div>
        </div>
        <div class="fixed-item" @click="onGourd">
            <div class="icon-gourd"></div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { openWebview, jsbReportV3 } from '@q-front-npm/jsbridge';
import { useStore } from '@/store';
const store = useStore();
const saClick = (btnName: string) => {
    jsbReportV3('moon_btn_button_click', { btn_wenan: btnName, });
};
const onRule = () => {
    saClick('规则');
    openWebview('https://xiaoshuo.wtzw.com/freereader-rules/68c91c86e4a81e7ec3130c41/');
};
const onRanking = () => {
    saClick('排行榜');
    openWebview(`${window.location.origin}/h5/activity/freereaderMidAutumn/ranking-list?full_screen=3&key=${store.indexData.activity_key}`);
};
const onGourd = () => {
    store.setPopStatus('view', true);
    saClick('法宝');
};
</script>
<style lang="scss" scoped>
.fixed-right {
    position: absolute;
    right: 0;
    top: 320px;
    z-index: 10;
    display: flex;
    flex-direction: column;
}
.fixed {
    &-rule {
        align-self: flex-end;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0));
        height: 40px;
        border-radius: 40px 0 0 40px;
        width: 72px;
        padding: 1px;
        &-text {
            width: 100%;
            height: 100%;
            font-size: 20px;
            color: rgba(255, 255, 255, 0.74);
            line-height: 1;
            background-color: #1c408f;
            border-radius: 40px 0 0 40px;
        }
    }
}

.fixed-item {
    &-first {
        margin-top: 160px;
    }

    width: 120px;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
